module.exports = require('./cjs');


//////////////////
// WEBPACK FOOTER
// ./${exlibris_product}/npm_modules/August2022-PROD/prima/node_modules/ng-forward/index.js
// module id = 432
// module chunks = 6